import styled from 'styled-components';

import { Colors, ContentSpacing, breakpoint } from '@estee/elc-base-theme';
import { Subtitle2 } from '@estee/elc-typography';
import { RemoveIcon } from '@estee/elc-icons';

import { ImageWrapper } from '~views/ImageWrapper/ImageWrapper';

const { space6, space8, space12, space16, space24 } = ContentSpacing;

export const inheritBaseFont = `
    font-family: inherit;
    color: inherit;
`;

export const cartItemCloseIconTheme = `
    stroke: ${Colors.primary600};
`;

export const cartItemActionLinkTheme = `
    text-decoration: underline;
    text-transform: uppercase;
`;

export const baseRemoveIcon = `
    min-width: 14px;
    min-height: 14px;
    background-color: ${Colors.primary700};
`;

export const Title = styled(Subtitle2)`
    animation: fadeIn 5s;
    text-transform: uppercase;
    word-wrap: break-word;
    white-space: nowrap;
    max-width: 200px;
    ${inheritBaseFont};
    overflow: hidden;
`;

export const defaultCTA = `
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: ${space8} ${space16} ${space24} ${space16};
    max-height: 48px;
    flex: 1;
    flex-shrink: 0;
`;

export const StyledFooter = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0 1 auto;
    flex-shrink: 0;
    border-radius: 1%;
    margin-bottom: -${space12};
    box-shadow: 0 -8px 6px -6px ${Colors.primary300};
    z-index: 1;
`;

export const StyledImageWrapper = styled(ImageWrapper)`
    width: 90px;
    min-width: 90px;
`;

export const TabContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 112px;
    overflow: auto;
    ${breakpoint('largeScreen')`
        max-width: 400px;
        width: 400px;
    `};
`;

export const RemoveButton = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    max-height: 20px;
    padding-bottom: 0;
    border: none;
    background: transparent;
    text-align: right;
    cursor: pointer;

    [dir='rtl'] & {
        text-align: left;
    }

    &:hover,
    &:focus {
        text-decoration: none;
    }
`;

export const RemoveIconWrapper = styled(RemoveIcon)`
    min-width: 14px;
    min-height: 14px;
    background-color: ${Colors.primary700};
`;

export const Price = styled(Subtitle2)`
    font-family: inherit;
`;

export const SpacedWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${space6};
    padding-bottom: ${space6};
`;
